module.exports = __webpack_public_path__ + "static/media/scan3.468972f5.png";